/** The board Die Cut Studio's dies are drawn for and their inch, in mm: what
 * their grows (DieCutStudioGrowList.ts) and their dies
 * (DieCutStudioDieList.ts) both measure by. */
export const DieCutStudioBoard = { thickness: 0.5, inch: 25.4 } as const
